interface Props {
  color?: string
  className?: string
}

export default function UsdtIcon({ color = 'currentColor', className }: Props) {
  return (
    <svg className={className} viewBox="0 0 1024 1024" fill={color}>
      <path d="M799.92 306.814v-140.32H225.401v140.32h211.807v91.675c-172.175 7.743-301.825 41.683-301.825 82.404 0 40.722 129.649 74.66 301.825 82.404v294.211h150.906v-294.28c171.511-7.86 300.503-41.738 300.503-82.336 0-40.603-128.992-74.492-300.503-82.342v-91.737H799.92z m23.831 165.789c0 26.782-100.251 49.247-235.637 55.484l-8.749 0.371h-0.967l-8.204 0.302h-0.888c-6.102 0.209-12.278 0.388-18.532 0.529h-0.388l-8.389 0.174h-2.371l-6.62 0.089h-41.923l-6.552-0.089h-2.276l-7.827-0.164h-0.86c-9.277-0.207-18.414-0.493-27.416-0.841h-0.118l-8.962-0.388c-136.061-6.142-236.958-28.685-236.958-55.595 0-26.916 100.914-49.392 236.958-55.602v85.107c23.617 1.231 48.74 1.906 74.796 1.906 26.471 0 52.101-0.686 76.116-1.974v-84.786c135.504 6.221 235.767 28.697 235.767 55.477z m0 0" />
    </svg>
  )
}
